import createStepByStepPage from './m50_stepbystep_factory';

export default createStepByStepPage('m50_u1_x5');
